import { render, staticRenderFns } from "./Stoper.vue?vue&type=template&id=8bb9da42&scoped=true&"
import script from "./Stoper.vue?vue&type=script&lang=js&"
export * from "./Stoper.vue?vue&type=script&lang=js&"
import style0 from "./Stoper.vue?vue&type=style&index=0&id=8bb9da42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb9da42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bb9da42')) {
      api.createRecord('8bb9da42', component.options)
    } else {
      api.reload('8bb9da42', component.options)
    }
    module.hot.accept("./Stoper.vue?vue&type=template&id=8bb9da42&scoped=true&", function () {
      api.rerender('8bb9da42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stoper.vue"
export default component.exports